/**
 * Lista ordenada de textos simples (slugs de categoria, perfis oficiais, metas
 * antigas). Cada linha é um campo editável; a validação do formato acontece no
 * cartão, e o erro de uma linha aparece sob ela.
 */
import { Button } from '@/components/atoms';
import type { ErroDeCampo } from '@/types/portal';

import { CampoTexto } from './campos';
import { erroDe, remover, trocar } from './helpers';
import styles from './Portal.module.css';

interface Props {
  rotulo: string;
  /** Como chamar uma linha ("Categoria", "Perfil"): vai nos rótulos acessíveis. */
  item: string;
  itens: string[];
  onChange: (itens: string[]) => void;
  erros: ErroDeCampo[];
  campo: string;
  placeholder?: string;
  dica?: string;
  max?: number;
  mono?: boolean;
}

export function EditorLista({
  rotulo,
  item,
  itens,
  onChange,
  erros,
  campo,
  placeholder,
  dica,
  max,
  mono,
}: Props) {
  const erroLista = erroDe(erros, campo);
  return (
    <div>
      <h4 className={styles.sub2}>
        {rotulo} ({itens.length})
      </h4>
      {dica && <p className={styles.dica}>{dica}</p>}
      {itens.length === 0 ? (
        <p className={styles.vazio}>Lista vazia.</p>
      ) : (
        <ul className={styles.lista} aria-label={rotulo}>
          {itens.map((v, i) => (
            <li key={i} className={styles.linha}>
              <CampoTexto
                rotulo={`${item} ${i + 1}`}
                valor={v}
                placeholder={placeholder}
                mono={mono}
                erro={erroDe(erros, `${campo}.${i}`)}
                onChange={(novo) => onChange(trocar(itens, i, novo))}
              />
              <div className={styles.linhaAcoes}>
                <Button
                  type="button"
                  size="sm"
                  variant="ghost"
                  onClick={() => onChange(remover(itens, i))}
                  aria-label={`Remover ${item.toLowerCase()} ${i + 1}`}
                >
                  Remover
                </Button>
              </div>
            </li>
          ))}
        </ul>
      )}
      {erroLista && <span className={styles.erroCampo}>{erroLista}</span>}
      <div style={{ marginTop: 'var(--sp-2)' }}>
        <Button
          type="button"
          size="sm"
          variant="secondary"
          disabled={max !== undefined && itens.length >= max}
          onClick={() => onChange([...itens, ''])}
        >
          Adicionar {item.toLowerCase()}
        </Button>
      </div>
    </div>
  );
}
